import React from 'react';

import { Box } from '@material-ui/core';

import { LegendsContainer } from '../styles';

export default function Legends({ data, onClick }) {
    return (
        <LegendsContainer display="flex" flexDirection="column" justifyContent="center">
            {data.map((legend) => (
                <Box
                    key={legend.id + legend.value}
                    display="flex"
                    alignItems="center"
                    onClick={() => (onClick ? onClick(legend) : {})}
                >
                    <div style={{ backgroundColor: legend.color }} />
                    <b>{legend.value}</b> {legend.id}
                </Box>
            ))}
        </LegendsContainer>
    );
}
